var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticStyle:{"height":"100%"}},[(_vm.searchEngine === 'googlesearchengine')?_c('GoogleSearch',{attrs:{"query":_vm.query,"is-from-quick-reply":_vm.isFromQuickReply}}):(_vm.searchEngine === 'silvercloud')?_c('SilverCloudSearch',{attrs:{"query":_vm.query,"is-from-quick-reply":_vm.isFromQuickReply}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }